export default __webpack_public_path__ + "static/media/logout.132114b1.svg";